<template>
  <el-card class="h-full brief-card">
    <div slot="header" class="clearfix">
      <span>简报</span>
      <el-button :loading="loading" style="float: right; padding: 3px 0" type="text" @click="handleExport">导出</el-button>
    </div>
    <div class="text-sm indent-8">
      <p v-for="(content, index) in contents" :key="index" class="mb-2">
        {{ content }}
      </p>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BriefData',
  data() {
    return {
      loading: false,
      contents: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleExport() {
      this.loading = true
      axios.get('/dashboard/brief_export').then(res => {
        this.loading = false

        if (res.data.status === 1) {
          // this.contents = res.data.contents
          window.open(res.data.url)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getData() {
      axios.get('/dashboard/brief').then(res => {
        if (res.data.status === 1) {
          this.contents = res.data.contents
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
